import React from 'react';

export default () => {
  return (
    <div className="flex flex-row items-center bg-[#1F1F1F] p-3 rounded-full m-4">
      <img src={'https://padel-uzh-module.web.app/assets/info_image.svg'} alt="" />
      <div className="info-price-container ml-4">
        <div className="flex flex-row items-center">
          <div className="round border-lower-price" />
          800 грн / год
        </div>
        <div className="flex flex-row items-center">
          <div className="round border-higher-price" />
          1100 грн / год
        </div>
      </div>
      <div className="info-divier ml-4 mr-4" />
      <div className="text-base text-white font-extrabold">Мінімальний час гри - 1 година</div>
    </div>
  );
};
